// Core
import React from "react";

// Styles
import "./styles.scss";

const ProgressBar = ({ completedPercentage, ProgressBarStyle, fillColor }) => {
  return (
    <div className="progress-bar" style={ProgressBarStyle}>
      <div
        className="progress-bar-filled"
        style={{ width: `${completedPercentage}%`, backgroundColor: fillColor }}
      ></div>
    </div>
  );
};

export default ProgressBar;
